import React from 'react';

import Input from '../Input/Input';
import Label from '../Label/Label';
import Description from '../Description/Description';

import styles from './AdaptiveBlock.module.css';
import { COMPANY_INFO_FIELDS } from '../../../common/fields';

const AdaptiveBlock = ({ mfaThreshold, mfaWindowSize, changed }) => {
    return (
        <div className={styles.adaptiveContainer}>
            <Label value="Adaptive Block (MFA Bombing Protection)" />
            <div className={styles.container}>
                <div>Block after</div>
                <Input
                    id={mfaThreshold.id}
                    value={mfaThreshold.value}
                    changed={changed}
                    featureLockId={COMPANY_INFO_FIELDS.AUTO_DENY_MFA_WINDOW_SIZE.ID}
                />
                <div>denied MFA requests in less than</div>
                <Input
                    id={mfaWindowSize.id}
                    value={mfaWindowSize.value}
                    changed={changed}
                    featureLockId={COMPANY_INFO_FIELDS.AUTO_DENY_MFA_WINDOW_SIZE.ID}
                />
                <div>minutes</div>
            </div>
            {mfaThreshold.error && <div className={styles.errorText}>{mfaThreshold.error}</div>}
            {mfaWindowSize.error && <div className={styles.errorText}>{mfaWindowSize.error}</div>}
            <Description value={mfaThreshold.desc} />
        </div>
    );
};

export default React.memo(AdaptiveBlock);
